import { Tooltip, Typography } from '@mui/material';

import { content } from './TerminPlanungsinformationenCard.content';

type RaumgroesseWithTooltipProps = { readonly value: string | undefined };

export const RaumgroesseWithTooltip = ({ value }: RaumgroesseWithTooltipProps) => {
  if (value) {
    return <Typography variant="labelLight">{`${value}${content.unitsWs.qm}`}</Typography>;
  }

  return (
    <Tooltip title={content.raumgroesseTooltip}>
      <Typography data-testid="raumgroesseNoInfoAvailable" variant="labelLight">
        -
      </Typography>
    </Tooltip>
  );
};
